import React from 'react';
import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LineElement,
    LineController,
    LinearScale,
    PointElement,
    Tooltip,
    plugins,
    scales,
    registerables
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { Paper, Typography } from '@mui/material';
import annotationPlugin from 'chartjs-plugin-annotation';
import { useEffect } from 'react';
// import { Line } from 'react-chartjs-2';

// ==============================|| USER LIST 1 ||============================== //
ChartJS.register(
    LineController,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Legend,
    Tooltip,
    scales,
    plugins,
    annotationPlugin,
    ...registerables
);
const LineChart = ({ chartData, title, annotations, showRightAxis, leftAxisLabel, rightAxisLabel }: any) => {
    const [options, setOptions] = React.useState<any>({
        responsive: true,
        scales: {
            left: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                    display: true,
                    text: leftAxisLabel,
                    font: {
                        weight: '600',
                        size: '16'
                    }
                }
            },
            right: {
                type: 'linear',
                display: showRightAxis,
                position: 'right',
                title: {
                    display: showRightAxis,
                    text: rightAxisLabel,
                    font: {
                        weight: '600',
                        size: '16'
                    }
                },
                // grid line settings
                grid: {
                    drawOnChartArea: false // only want the grid lines for one axis to show up
                }
            }
        },
        plugins: {
            annotation: {
                annotations: {}
            }
        }
    });

    useEffect(() => {
        let tempOptions = { ...options };
        annotations.forEach((annotation: any) => {
            tempOptions.plugins.annotation.annotations[annotation.key] = {
                type: 'box',
                backgroundColor: annotation.backgroundColor,
                borderWidth: 0,
                xMin: annotation.xMin,
                xMax: annotation.xMax,
                label: {
                    drawTime: 'afterDraw',
                    display: true,
                    content: annotation.title,
                    position: {
                        x: 'center',
                        y: 'start'
                    }
                }
            };
        });
        setOptions(tempOptions);
    }, [annotations]);

    return (
        <div style={{ width: '100%', marginTop: '2rem' }}>
            <Paper style={{ width: '100%', padding: '20px' }}>
                <Typography key={'Title_' + title} style={{ padding: '10px', fontWeight: 'bold', fontSize: '1.3rem', textAlign: 'center' }}>
                    {title}
                </Typography>
                <Chart key={'Chart_' + title} type="line" height={90} data={chartData} options={options} plugins={[annotationPlugin]} />
            </Paper>
        </div>
    );
};

export default LineChart;
